import { Reveal } from "./motion";
import { IMG } from "./data";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    no: "01",
    title: "Klassische Reinigung",
    img: IMG.commercial,
    tag: "Unterhalt & Gebäude",
    desc: "Büros, Praxen, Treppenhäuser und Wohnobjekte — zuverlässige Unterhalts- und Grundreinigung, die Ihre Räume jeden Tag in Bestform hält.",
    points: ["Unterhaltsreinigung", "Fenster- & Glasreinigung", "Bau- & Grundreinigung", "Umzugsreinigung mit Abnahmegarantie"],
  },
  {
    no: "02",
    title: "Industriereinigung",
    img: IMG.industrial,
    tag: "Produktion & Anlagen",
    desc: "Hallen, Maschinen und Produktionsanlagen. Wir arbeiten normkonform, sicherheitsbewusst und auch dann, wenn der Betrieb nicht stillstehen darf.",
    points: ["Hallen- & Bodenreinigung", "Maschinen- & Anlagenreinigung", "Fassaden- & Höhenreinigung", "Sonder- & Baustellenreinigung"],
  },
];

export default function Services() {
  return (
    <section id="leistungen" className="relative bg-[#0d0d0f] py-24 lg:py-36">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-16 flex flex-col gap-6 lg:mb-24 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="mb-5 flex items-center gap-4">
              <span className="h-px w-12 bg-[#4fd1c5]" />
              <span className="font-mono-spc text-[11px] uppercase tracking-[0.35em] text-[#4fd1c5]">Leistungen</span>
            </div>
            <Reveal>
              <h2 className="max-w-2xl font-head text-4xl font-light uppercase tracking-tighter text-metal sm:text-5xl lg:text-6xl">
                Zwei Disziplinen. Ein Standard.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="max-w-sm font-light leading-relaxed text-[#c0c5ce]/70">
              Ob Alltag oder Ausnahmezustand — wir liefern messbare Sauberkeit
              mit dokumentierten Prozessen.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.12}>
              <article
                data-testid={`service-card-${s.no}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-sm border border-white/5 bg-[#111214] transition-[transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-[#4fd1c5]/50"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="h-full w-full object-cover grayscale transition-[filter,transform] duration-[900ms] ease-out group-hover:grayscale-0 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111214] via-transparent to-transparent" />
                  <span className="absolute left-6 top-6 font-mono-spc text-[11px] tracking-[0.3em] text-[#4fd1c5]">
                    {s.tag}
                  </span>
                  <span className="absolute right-6 top-6 font-head text-5xl font-light text-white/15">{s.no}</span>
                </div>

                <div className="flex flex-1 flex-col p-8 lg:p-10">
                  <div className="mb-6 flex items-start justify-between gap-4">
                    <h3 className="font-head text-2xl font-medium tracking-tight text-white lg:text-3xl">{s.title}</h3>
                    <ArrowUpRight className="mt-1 h-6 w-6 shrink-0 text-[#4fd1c5] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
                  </div>
                  <p className="mb-8 font-light leading-relaxed text-[#c0c5ce]/70">{s.desc}</p>
                  <ul className="mt-auto grid grid-cols-1 gap-y-3 sm:grid-cols-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 font-mono-spc text-[12px] tracking-wide text-[#c0c5ce]/80">
                        <span className="h-1 w-1 rounded-full bg-[#4fd1c5]" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
